import { render } from "./Loader.vue?vue&type=template&id=5d5d7282"
import script from "./Loader.vue?vue&type=script&lang=js"
export * from "./Loader.vue?vue&type=script&lang=js"
script.render = render

export default script